import { render, staticRenderFns } from "./ApplyExternalResearchGroup.html?vue&type=template&id=0b985472&scoped=true&"
import script from "./ApplyExternalResearchGroup.vue?vue&type=script&lang=js&"
export * from "./ApplyExternalResearchGroup.vue?vue&type=script&lang=js&"
import style0 from "./ApplyExternalResearchGroup.scss?vue&type=style&index=0&id=0b985472&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b985472",
  null
  
)

export default component.exports